// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lp-0";